'use client';

import { scrollTo } from '@/utils';
import clsx from 'clsx';
import { ReactNode } from 'react';
import { useTranslation as t } from '../../hooks/useTranslation';
import { EpIcon } from '../EpIcon';
import { skipToStepReview } from '../EpWizard';
import styles from './EpStepReview.module.scss';

interface IEpStepReviewProps {
  children?: ReactNode;
  step: number;
  title: string;
  translations?: string[];
}

interface FiledLineProps {
  label: string;
  text: string;
  block?: boolean;
}

export const FieldLine = ({ label, text, block = false }: FiledLineProps) => {
  // -- linha debaixo desabilitada para verificar os erros de não preenchimento
  if (!text) return null;
  return (
    <div className={`${styles['fieldline']} ${clsx(block && styles['block'])}`}>
      <p className={styles['fieldline__text']}>{text}</p>
      <p className={styles['fieldline__label']}>{label}</p>
    </div>
  );
};

export const FieldLineDescription = ({ label, text, block = false }: FiledLineProps) => {
  // -- linha debaixo desabilitada para verificar os erros de não preenchimento
  if (!text) return null;
  return (
    <div className={`${styles['fieldline_description']} ${clsx(block && styles['block'])}`}>
      <p className={styles['fieldline_description__label']}>{label}</p>
      <p className={styles['fieldline_description__text']}>{text}</p>
    </div>
  );
};

export const EpStepReview = ({
  children,
  step,
  title,
  translations,
}: IEpStepReviewProps) => {
  const handleStep = () => {
    scrollTo(['main']);
    skipToStepReview(step - 1);
  };

  return (
    <div className={styles['container']}>
      <div>
        <div className={styles['container__card']}>
          <div className={styles['head']}>
            <h5 className={styles['typograph__title']}>{title}</h5>
            <button
              type="button"
              className={styles['btn']}
              onClick={() => handleStep()}
            >
              <EpIcon iconName="SolidPencilAlt" />
              <span>{t(translations, 'Edit')}</span>
            </button>
          </div>
          <div className={styles['content']}>{children}</div>
        </div>
      </div>
    </div>
  );
};
